var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaultEarnings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 162,
    viewBox: "0 0 105 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75_1771",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 162
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 162,
    rx: 16,
    fill: "#3E3E3E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3893 134.498C-0.808213 134.498 -10.8018 125.632 -10.8018 114.715V104.26C-10.8018 102.159 -9.05926 100.417 -6.95801 100.417C-4.85676 100.417 -3.11426 102.159 -3.11426 104.26C-3.11426 110.667 3.08679 115.484 11.3893 115.484C19.6918 115.484 25.8931 110.667 25.8931 104.26C25.8931 102.159 27.6355 100.417 29.7368 100.417C31.838 100.417 33.5805 102.159 33.5805 104.26V114.715C33.5805 125.632 23.638 134.498 11.3893 134.498ZM-1.78201 119.738C0.472988 123.94 5.54679 126.81 11.3893 126.81C17.2318 126.81 22.3056 123.889 24.5606 119.738C20.9218 121.942 16.4118 123.223 11.3893 123.223C6.36679 123.223 1.85674 121.942 -1.78201 119.738Z",
    fill: "url(#paint0_linear_75_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3893 109.128C2.98429 109.128 -4.54931 105.284 -8.29056 99.1857C-9.93056 96.5207 -10.8018 93.3944 -10.8018 90.2169C-10.8018 84.8357 -8.44431 79.8132 -4.13931 76.0719C4.16319 68.7946 18.4618 68.7949 26.8155 76.0212C31.1205 79.8137 33.5293 84.8357 33.5293 90.2169C33.5293 93.3944 32.658 96.5207 31.018 99.1857C27.328 105.284 19.7943 109.128 11.3893 109.128ZM11.3893 78.1225C7.39178 78.1225 3.70189 79.4544 0.934388 81.8632C-1.67936 84.1182 -3.11426 87.0907 -3.11426 90.2169C-3.11426 92.0107 -2.65321 93.6512 -1.73071 95.1887C0.626786 99.0837 5.64928 101.492 11.3893 101.492C17.1293 101.492 22.1517 99.0837 24.458 95.24C25.3805 93.7537 25.8418 92.0625 25.8418 90.2687C25.8418 87.1425 24.4069 84.1694 21.7932 81.8632C19.0769 79.4544 15.3868 78.1225 11.3893 78.1225Z",
    fill: "url(#paint1_linear_75_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3893 123.225C-1.26946 123.225 -10.8018 115.076 -10.8018 104.314V90.22C-10.8018 79.3037 -0.859463 70.4375 11.3893 70.4375C17.1805 70.4375 22.7156 72.4363 26.8668 76.0238C31.1718 79.8163 33.5805 84.8387 33.5805 90.22V104.314C33.5805 115.076 24.048 123.225 11.3893 123.225ZM11.3893 78.125C3.39429 78.125 -3.11426 83.5575 -3.11426 90.22V104.314C-3.11426 110.72 3.08679 115.537 11.3893 115.537C19.6918 115.537 25.8931 110.72 25.8931 104.314V90.22C25.8931 87.0937 24.4582 84.1213 21.8445 81.815C19.077 79.4575 15.3868 78.125 11.3893 78.125Z",
    fill: "url(#paint2_linear_75_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2231 93.7571C64.4844 93.7571 57.9244 88.0171 57.3094 80.6371C56.8994 76.3834 58.4369 72.2321 61.5119 69.2084C64.0744 66.5433 67.7131 65.0571 71.5569 65.0571H82.2681C87.3419 65.2109 91.2369 69.2084 91.2369 74.1284V84.6859C91.2369 89.6059 87.3419 93.6034 82.4219 93.7571H72.2231ZM82.1144 72.7446H71.6081C69.8144 72.7446 68.1744 73.4109 66.9956 74.6409C65.5094 76.0759 64.7919 78.0234 64.9969 79.9709C65.2531 83.3534 68.5331 86.0696 72.2231 86.0696H82.2681C82.9344 86.0696 83.5494 85.4546 83.5494 84.6859V74.1284C83.5494 73.3596 82.9344 72.7959 82.1144 72.7446Z",
    fill: "url(#paint3_linear_75_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6449 126.812H43.8323C41.7311 126.812 39.9886 125.07 39.9886 122.969C39.9886 120.868 41.7311 119.125 43.8323 119.125H56.6449C69.8673 119.125 78.4261 110.566 78.4261 97.3438V93.7563H72.2248C64.4861 93.7563 57.9261 88.0163 57.3111 80.6362C56.9011 76.3825 58.4391 72.2313 61.5141 69.2075C64.0766 66.5426 67.7148 65.0563 71.5586 65.0563H78.3748V61.4688C78.3748 49.4762 71.3541 41.2249 59.9766 39.8924C58.7466 39.6874 57.6698 39.6875 56.5936 39.6875H10.4688C9.23875 39.6875 8.05995 39.7899 6.8812 39.9437C-4.3938 41.3787 -11.3125 49.5788 -11.3125 61.4688V71.7188C-11.3125 73.82 -13.055 75.5625 -15.1562 75.5625C-17.2575 75.5625 -19 73.82 -19 71.7188V61.4688C-19 45.6838 -9.2623 34.2551 5.85645 32.3588C7.24021 32.1538 8.82875 32 10.4688 32H56.5936C57.8236 32 59.4124 32.0512 61.0524 32.3075C76.1711 34.05 86.0623 45.53 86.0623 61.4688V68.9001C86.0623 71.0013 84.3198 72.7437 82.2186 72.7437H71.5586C69.7648 72.7437 68.1254 73.41 66.9466 74.64C65.4604 76.075 64.7423 78.0225 64.9473 79.97C65.2036 83.3525 68.4841 86.0688 72.1741 86.0688H82.2698C84.3711 86.0688 86.1136 87.8113 86.1136 89.9125V97.3438C86.1136 114.974 74.2748 126.812 56.6449 126.812Z",
    fill: "url(#paint4_linear_75_1771)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_1771",
    x1: -9.59133,
    y1: 134.498,
    x2: 39.4403,
    y2: 115.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_1771",
    x1: -9.59273,
    y1: 109.128,
    x2: 40.7958,
    y2: 92.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_1771",
    x1: -9.59133,
    y1: 123.225,
    x2: 43.3984,
    y2: 110.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_1771",
    x1: 58.1712,
    y1: 93.7571,
    x2: 96.5748,
    y2: 80.3697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_1771",
    x1: -16.1333,
    y1: 126.812,
    x2: 104.235,
    y2: 87.5365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultEarnings);
export default __webpack_public_path__ + "static/media/vaultEarnings.336bb3bb49728bd9b4a8bcb559a3d9a9.svg";
export { ForwardRef as ReactComponent };